<template>
  <label
    class="base-radio"
    :class="[{ isDisabled }]"
  >
    <input
      v-model="model"
      type="radio"
      :value="label"
      :checked="label === model"
      :disabled="isDisabled"
      class="base-radio__input"
      @change="handleChange"
    />
    <div class="base-radio__inner">
      <slot>{{label}}</slot>
    </div>
  </label>
</template>

<script>
export default {
  name: 'BaseRadio',

  props: {
    label: null, // 选框的值，固定不变的
    value: null, // value值，随着选择的选框不同会发生变化
    disabled: Boolean
  },

  computed: {
    radioGroup () {
      let parent = this.$parent
      while (parent) {
        if (parent.$options.componentName !== 'BaseRadioGroup') {
          parent = parent.$parent
        } else {
          return parent
        }
      }
      return null
    },
    model: {
      get () {
        return this.radioGroup ? this.radioGroup.value : this.value
      },
      set (value) {
        if (this.radioGroup) {
          this.dispatch('BaseRadioGroup', 'input', value)
        } else {
          this.$emit('input', value)
        }
      }
    },
    isDisabled () {
      return this.radioGroup ? this.radioGroup.disabled || this.disabled : this.disabled
    }
  },

  methods: {
    handleChange () {
      this.$nextTick(() => {
        this.$emit('change', this.model)
        this.radioGroup && this.dispatch('BaseRadioGroup', 'handleChange', this.model)
      })
    },
    dispatch (componentName, eventName, params) {
      let parent = this.$parent || this.$root
      let name = parent.$options.componentName
      while (parent && !(name && name === componentName)) {
        parent = parent.$parent
        if (parent) {
          name = parent.$options.componentName
        }
      }
      if (parent) parent.$emit.apply(parent, [ eventName ].concat(params))
    }
  }
}
</script>

<style lang="scss" scoped>
  .base-radio {
    display: inline-block;
    &__input {
      position: absolute;
      z-index: -1;
      width: 0;
      height: 0;
      outline: none;
      opacity: 0;
      &:checked + .base-radio__inner {
        border: 1px solid $--color-primary;
        background-color: $--color-primary;
        color: #fff;
      }
    }

    &__inner {
      position: relative;
      display: inline-block;
      padding: 0 10px;
      overflow: hidden;
      width: 100%;
      border: 1px solid #ddd;
      color: #2a2c31;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
      border-radius: 4px;
    }

    & + & {
      margin-left: 5px;
    }
  }
</style>
